/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { PowerBISettings } from "../models/power-bisettings";
@Injectable({
  providedIn: "root",
})
class PowerBIService extends __BaseService {
  static readonly powerBIGetPowerBISettingsPath =
    "/api/PowerBI/GetPowerBISettings";
  static readonly powerBIGetPowerBIEmbedTokenPath =
    "/api/PowerBI/GetPowerBIEmbedToken";
  static readonly powerBIGetPowerBISettingsForInteractivePath =
    "/api/PowerBI/GetPowerBISettingsForInteractive";
  static readonly powerBIGetPowerBISettingsForModifiedInteractivePath =
    "/api/PowerBI/GetPowerBISettingsForModifiedInteractive";
  static readonly powerBIGetPowerBISettingsForReportStandardTypePath =
    "/api/PowerBI/GetPowerBISettingsForReportStandardType";
  static readonly powerBIGetPowerBISettingsForReportEmbeddedTypePath =
    "/api/PowerBI/GetPowerBISettingsForReportEmbeddedType";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  powerBIGetPowerBISettingsResponse(): __Observable<
    __StrictHttpResponse<PowerBISettings>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PowerBI/GetPowerBISettings`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PowerBISettings>;
      })
    );
  }
  powerBIGetPowerBISettings(): __Observable<PowerBISettings> {
    return this.powerBIGetPowerBISettingsResponse().pipe(
      __map((_r) => _r.body as PowerBISettings)
    );
  }

  /**
   * @param powerBiReportId undefined
   */
  powerBIGetPowerBIEmbedTokenResponse(
    powerBiReportId?: string
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (powerBiReportId != null)
      __params = __params.set("powerBiReportId", powerBiReportId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PowerBI/GetPowerBIEmbedToken`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param powerBiReportId undefined
   */
  powerBIGetPowerBIEmbedToken(powerBiReportId?: string): __Observable<string> {
    return this.powerBIGetPowerBIEmbedTokenResponse(powerBiReportId).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param interactId undefined
   */
  powerBIGetPowerBISettingsForInteractiveResponse(
    interactId?: number
  ): __Observable<__StrictHttpResponse<PowerBISettings>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactId != null)
      __params = __params.set("interactId", interactId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PowerBI/GetPowerBISettingsForInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PowerBISettings>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  powerBIGetPowerBISettingsForInteractive(
    interactId?: number
  ): __Observable<PowerBISettings> {
    return this.powerBIGetPowerBISettingsForInteractiveResponse(
      interactId
    ).pipe(__map((_r) => _r.body as PowerBISettings));
  }

  /**
   * @param interactId undefined
   */
  powerBIGetPowerBISettingsForModifiedInteractiveResponse(
    interactId?: number
  ): __Observable<__StrictHttpResponse<PowerBISettings>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (interactId != null)
      __params = __params.set("interactId", interactId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PowerBI/GetPowerBISettingsForModifiedInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PowerBISettings>;
      })
    );
  }
  /**
   * @param interactId undefined
   */
  powerBIGetPowerBISettingsForModifiedInteractive(
    interactId?: number
  ): __Observable<PowerBISettings> {
    return this.powerBIGetPowerBISettingsForModifiedInteractiveResponse(
      interactId
    ).pipe(__map((_r) => _r.body as PowerBISettings));
  }

  /**
   * @param reportStandardTypeId undefined
   */
  powerBIGetPowerBISettingsForReportStandardTypeResponse(
    reportStandardTypeId?: number
  ): __Observable<__StrictHttpResponse<PowerBISettings>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportStandardTypeId != null)
      __params = __params.set(
        "reportStandardTypeId",
        reportStandardTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PowerBI/GetPowerBISettingsForReportStandardType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PowerBISettings>;
      })
    );
  }
  /**
   * @param reportStandardTypeId undefined
   */
  powerBIGetPowerBISettingsForReportStandardType(
    reportStandardTypeId?: number
  ): __Observable<PowerBISettings> {
    return this.powerBIGetPowerBISettingsForReportStandardTypeResponse(
      reportStandardTypeId
    ).pipe(__map((_r) => _r.body as PowerBISettings));
  }

  /**
   * @param reportEmbeddedTypeId undefined
   */
  powerBIGetPowerBISettingsForReportEmbeddedTypeResponse(
    reportEmbeddedTypeId?: number
  ): __Observable<__StrictHttpResponse<PowerBISettings>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (reportEmbeddedTypeId != null)
      __params = __params.set(
        "reportEmbeddedTypeId",
        reportEmbeddedTypeId.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PowerBI/GetPowerBISettingsForReportEmbeddedType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PowerBISettings>;
      })
    );
  }
  /**
   * @param reportEmbeddedTypeId undefined
   */
  powerBIGetPowerBISettingsForReportEmbeddedType(
    reportEmbeddedTypeId?: number
  ): __Observable<PowerBISettings> {
    return this.powerBIGetPowerBISettingsForReportEmbeddedTypeResponse(
      reportEmbeddedTypeId
    ).pipe(__map((_r) => _r.body as PowerBISettings));
  }
}

module PowerBIService {}

export { PowerBIService };
